import { IApplicationContext } from 'shared/types/applicationContext';

import { ResponseError } from 'shared/errors';

import { ILocation } from 'shared/types/location';
import {
  ICianApiSiteV1SearchRegionsCitiesRequest,
  fetchCianApiSiteV1SearchRegionsCities,
  TCianApiSiteV1SearchRegionsCitiesResponse,
} from 'shared/repositories/monolith-python/cian-api/site/v1/search-regions-cities';

export async function fetchLocationsByQuery(
  context: IApplicationContext,
  parameters: ICianApiSiteV1SearchRegionsCitiesRequest,
): Promise<ILocation[]> {
  try {
    const {
      httpApi,
      custom: { subdomain },
    } = context;

    const { response, statusCode }: TCianApiSiteV1SearchRegionsCitiesResponse =
      await fetchCianApiSiteV1SearchRegionsCities({
        httpApi,
        parameters,
        config: {
          subdomain,
        },
      });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchLocationsByQuery',
        message: response.data.message || '',
        details: {
          error: JSON.stringify(response.data.errors),
        },
      });
    }

    return response.data.items || [];
  } catch (ex) {
    const { logger } = context;

    logger.warning(
      {
        ...ex,
        details: {
          ...ex.details,
          microserviceName: 'monolith-python',
          pathApi: '/public/v1/search-regions-cities/',
          parameters: JSON.stringify(parameters),
        },
      },
      {
        degradation: 'Запрос информации о гео по строке',
      },
    );

    return [];
  }
}
